<template>
    <div>
        <Navigation :route="navigationRoute"></Navigation>
        <div class="mt-20">
        <div class="table" v-if="tab == 1">
          <div class="head">
            <div >序号</div>
            <div class="flex-2">课程名称</div>
            <div>学时</div>
            <div>时长（分钟）</div>
            <!-- <div>操作</div> -->
          </div>
          <div class="" >
            <div class="table-row" v-for="(e,i) in list" :key="i">
              <div>{{i+1}}</div>
              <div class="flex-2">{{e.name}}</div>
              <div>{{e.hours}}</div>
              <div>{{e.duration}}</div>
              <!-- <div>
                <div class="table-btn" @click="handleCourse(e)">查看</div>
              </div> -->
            </div>
            
          </div>
        </div>
        
        </div>
        <!-- <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination> -->
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { recommonCourselist } from "@/api/statistics.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "",
    components: {
        Navigation
    },
    data() {
        return {
            navigationRoute: [
                { name: '学时统计' },
                { name: '学时情况' },
                { name: '推荐课程' },
            ],
            tab: 1,            
            query: {
                current: 1,
                size: 10
            },
            tableData: { //表格数据
                total: 0,
                records: []
            },
            list:[],
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {
        handleCourse(e) {
            this.$router.push({ path: '/myTrain/course?id='+e.id })
        },
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            this.query.current = pageNumber || this.query.current
            this.query.size = pageSize || this.query.size
              recommonCourselist(this.query).then(res => {
                this.list = res
              })
           
            
        },
        
       
    },
};
</script>
<style lang="scss" scoped>
.tabs {
    display: flex;
    line-height: 30px;
    background: #FFFFFF;
    font-size: 14px;
    color: #EA0000;

    .tab {
        box-sizing: border-box;
        border: 1px solid #EA0000;
        border-radius: 3px 0 0 3px;
        padding: 0 22px;
        margin: 28px 0 25px 0;
        cursor: pointer;

        &:last-child {
            border-radius: 0 3px 3px 0;
            border-left: none;
        }
    }

    .active {
        background: #EA0000;
        color: #FFFFFF;
    }
}

.table {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  border-right: 1px solid #E3E3E3;
  border-bottom: 1px solid #E3E3E3;

  .head {
    display: flex;
    background: #EEEEEE;
    border-top: 1px solid #E3E3E3;
    border-left: 1px solid #E3E3E3;

    div {
      flex: 1;
      border-right: 1px solid #E3E3E3;
      padding: 10px 0;

      &:last-child {
        border-right: none;
      }
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }
  }

  .table-row {
    display: flex;

    >div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      border-top: 1px solid #E3E3E3;
      border-left: 1px solid #E3E3E3;
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }

    .table-btn {

      width: 74px;
      line-height: 24px;
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      border-radius: 3px 3px 3px 3px;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>